// extracted by mini-css-extract-plugin
export default {"statusTag":"StatusTag_statusTag__Kvp13"};